var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.611 22.389A5.464 5.464 0 0 1 14 18.5c0-1.468.572-2.849 1.611-3.888A5.465 5.465 0 0 1 19.5 13c1.469 0 2.85.573 3.889 1.612A5.463 5.463 0 0 1 25 18.5c0 1.469-.572 2.85-1.611 3.889A5.464 5.464 0 0 1 19.5 24a5.464 5.464 0 0 1-3.889-1.611Zm13.392 4.907-4.57-4.571A6.446 6.446 0 0 0 26 18.5a6.453 6.453 0 0 0-1.904-4.595A6.456 6.456 0 0 0 19.5 12a6.458 6.458 0 0 0-4.596 1.905A6.453 6.453 0 0 0 13 18.5c0 1.737.676 3.368 1.904 4.596A6.457 6.457 0 0 0 19.5 25a6.446 6.446 0 0 0 4.226-1.568l4.57 4.571.707-.707Z",
    fill: "#000624"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19 16h1v5h-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17 19v-1h5v1z"
  })));
};
export default SvgZoomIn;